import { render } from "./TemporalTripsTab.vue?vue&type=template&id=0c814a86&scoped=true"
import script from "./TemporalTripsTab.vue?vue&type=script&lang=js"
export * from "./TemporalTripsTab.vue?vue&type=script&lang=js"

import "./TemporalTripsTab.vue?vue&type=style&index=0&id=0c814a86&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c814a86"]])

export default __exports__